import { Divider } from "antd";
import React from "react";
import styles from "./styles.module.less";

const { container, icon, text } = styles;

interface IProps {
  Icon: any;
  title: string;
  Content: any;
}

const Block: React.FC<IProps> = ({ Icon, Content, title }) => {
  return (
    <div>
      <Divider orientation="left">
        <div className={container}>
          <div className={icon}>{Icon}</div>
          <div className={text}>{title}</div>
        </div>
      </Divider>
      {Content}
    </div>
  );
};

export default Block;
